import React from "react";
import { EditOutlined } from "@mui/icons-material";
import {  Button, Divider } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import EnableDisableButton from "components/Shared/EnableDisableButton";


import {
  useGetSendOutDetailQuery,
  useUpdateSendOutMutation,
} from "store/services/sendOutApi";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { SendOutDetailContext, useSendOutDetailContext } from "contexts/SendOutDetailContext";
import SendOutBasicDetail from "./SendOutComponent/SendOutBasicDetail";
import SendOutDetailTab from "./SendOutComponent/SendOutDetailTab";
import { useAuth } from "hooks";
const SendOutDetailScreen = () => {
  const { id } = useParams();
  const {isDriver} = useAuth();

  const breadcrumb = [
    { title: "Send Out", path: !isDriver ? "/app/crm/sendOut/list" : "/app/driver/sendOut" },
    { title: "Send Out Detail" },
  ];

  const {
    data: sendOutDetail,
    isLoading: loadingSendOut,
    error,
  } = useGetSendOutDetailQuery(id);

  return (
    <SendOutDetailContext.Provider value={{ sendOutDetail, loadingSendOut }}>
      <BreadcrumbLayout
        breadcrumbs={breadcrumb}
        isBusy={loadingSendOut}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />
        <BreadcrumbLayout.Paper>
          <SendOutBasicDetail />
          <Divider/>
          <SendOutDetailTab/>
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </SendOutDetailContext.Provider>
  );
};

export default SendOutDetailScreen;

const PageActions = () => {

  const { isDriver, isAccountAdmin } = useAuth();

  const { sendOutDetail, loadingSendOut } = useSendOutDetailContext();
  const [updateSendOut, { isLoading: updatingSendOut }] =
    useUpdateSendOutMutation();

  const handleToggleStatus = async () => {
    try {
      await updateSendOut({
        _id: sendOutDetail._id,
        isActive: !sendOutDetail.isActive,
      }).unwrap();
      toast.info(`Send Out ${sendOutDetail.isActive ? "Disabled" : "Enabled"}!`);
    } catch (error) {
      toast.error(error?.data?.message ?? "Could Not Update Status");
    }
  };

  return (
    <>
    {!isDriver && (<div className="flex space-x-4">
        {isAccountAdmin &&(<EnableDisableButton
        isActive={sendOutDetail?.isActive}
        loading={loadingSendOut || updatingSendOut}
        onClick={handleToggleStatus}
      />)}

      <Link to={`/app/crm/sendOut/${sendOutDetail?._id}/edit`}>
        <Button startIcon={<EditOutlined />} variant="contained">
          Edit
        </Button>
      </Link>
  

    </div>)}
    </>
  );
};
